/**
 * Constants and configuration options for settings page
 *
 * @prettier
 * @author Alexander Nagelberg
 * @since 24.3
 */
//@ts-check
export enum SettingsAuthorizations {
  ViewSettings = 'View Enterprise Settings'
}

export enum SettingsGearURL {
  Page = '/lgyhub/admin/settings/:pageId',
  Section = '/lgyhub/admin/settings/:pageId/:sectionId'
}

export enum SettingsAPIURL {
  FetchAllPages = '/lgyhub/api/settings',
  FetchPage = '/lgyhub/api/settings/:pageId',
  UpdateOptions = '/lgyhub/api/settings'
}

/**
 * Fills out tokens in a URL string with tokens provided
 *
 * @param URL string with URL path containing ':token' style tokens
 * @param tokens Dictionary of token name to value
 * @returns fully formed URL
 */
export const replaceTokens = (URL: SettingsGearURL | SettingsAPIURL | string, tokens: { [index: string]: string }) => {
  let path = `${URL}`
  Object.keys(tokens).forEach(key => (path = path.split(`:${key}`).join(tokens[key])))
  return path
}
